import axios from 'axios';
import Vue from "vue"; 
let baseUrl = "http://localhost:8000/api"
let config = {
    headers: {
        'Content-Type': 'application/json',
    } 
}
export default {
    async get(url,body, isAuthenticated=false){
        if(isAuthenticated){
            config.headers["Authorization"]=""
        }
        try {
            let request = await axios.get(baseUrl+url,body,config)
            return request.data
        } catch (error) {
            if(error.response.status==401){
                Vue.$router.push({ path: '/admin', params: { "status":"token-authdated" } })
            }

        }
        
    },
    async post(url,body,isAuthenticated=false){
        if(isAuthenticated){
            config.headers["Authorization"]=""
        }
        try {
            let response = await axios.post(baseUrl+url,body,config)
            return response.data
        } catch (error) {
            if(error.response.status==401){
                Vue.$router.push({ path: '/admin', params: { "status":"token-authdated" } })
            }

        }
    }
}